import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';

@Component({
  name: 'subscribe-popup',
})
export default class SubscribePopUp extends Vue {
  // Props
  @Prop({ type: Boolean, required: true })
  private visible!: boolean;
  @Prop({ type: String, default: 'Subscribe Popup' })
  private title!: string;
  @Prop({ type: Array, default: () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] })
  private dropdownOptions1!: string[];
  @Prop({ type: Array, default: () => ['default', 'route', 'suggestion'] })
  private dropdownOptions2!: string[];

  // New props
  @Prop({ type: Number, default: 0 })
  private rank!: number | null;
  @Prop({ type: String, default: 'route' })
  private useBy!: string | null;
  @Prop({ type: Boolean, default: null })
  private isMandatoryProduct!: boolean | null;

  // Local reactive copies
  private localRank: number | null = null;
  private localUseBy: string | null = null;
  private localIsMandatoryProduct: boolean | null = null;

  // Initialize locals from props
  private created() {
    this.localRank = Number(this.dropdownOptions1[0]);
    this.localUseBy = this.dropdownOptions2[1];
    this.localIsMandatoryProduct = false;
  }

  // Watches keep props in sync if parent updates
  @Watch('rank')
  private onRankChanged(newVal: number | null) {
    this.localRank = newVal;
  }

  @Watch('useBy')
  private onUseByChanged(newVal: string | null) {
    this.localUseBy = newVal;
  }

  @Watch('isMandatoryProduct')
  private onIsMandatoryChanged(newVal: boolean | null) {
    this.localIsMandatoryProduct = newVal;
  }

  @Watch('localUseBy')
  private onLocalUseByChanged(newVal: string | null) {
    if (newVal === 'default') {
      this.localRank = 0; // explicitly set to 0
    }
  }

  // Emits
  @Emit('cancel')
  private onCancel(): void {
    // nothing required here, just emit event
  }

  @Emit('subscribe')
  private onSubscribe() {
    return {
      rank: this.localRank,
      useBy: this.localUseBy,
      isMandatoryProduct: this.localIsMandatoryProduct,
    };
  }
}
